import { FormControl } from '@angular/forms';


interface ValidationResult {
    [key: string]: boolean;
}

export class FlxValidators {

    static emailValidator(control: FormControl): ValidationResult {
        let EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var valid = EMAIL_REGEXP.test(control.value);
        if (control.value.length === 0) return { required: true };
        if (!valid) {
            return { format: true };
        }
        return null;
    }

    static phoneValidator(control: FormControl): ValidationResult {
        let TEL_REGEXP = /\(?([0-9]{3})\)?([ ]?)([0-9]{3})?([-]?)\2([0-9]{4})/;
        var valid = null;
        if (control.value) {
            valid = TEL_REGEXP.test(control.value);
            if (control.value.length === 0) return null;
            if (control.value.length === 15) {
                control.setValue(control.value.slice(0, -1));
            }
            if (control.value.length === 1 && isNaN(control.value)) return { required: true };

            if (!valid) {
                return { format: true };
            }
        }
        
        return null;
    }

    static numberValidator(control: FormControl): ValidationResult {
        let NUMBER_REGEXP = /[0-9]*\.?[0-9]*/;
        var valid = NUMBER_REGEXP.test(control.value);
        if (control.value.length === 0) return null;
        if (!valid || control.value === '') {
            return { format: true };
        }
        return null;
    }

    static zipCodeValidator(control: FormControl): ValidationResult {
        let ZIP_REGEXP = /^[ABCEGHJKLMNPRSTVXY-abceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$/;
        // For some reason the mask adds a final character. We need to remove it.
        if (control.value.length === 8) {
            control.setValue(control.value.slice(0, -1));
        }
        if (control.value.length === 0) return { required: true };
        var valid = ZIP_REGEXP.test(control.value);
        if (!valid) {
            return { format: true };
        }
        return null;
    }

    static minValueValidator = (min: number) => {
        return (control: FormControl) => {
            let value = control.value;
            if (value !== '') {
                if (value < min) {
                    return { wrongRequestedAmount: true };
                }
            }
            return null;
        };
    }

    static currencyMaxValidator = (max: number) => {
        return (control: FormControl) => {
            let controlValue;
            if (control.value.length === 0 || (control.value.length === 1 && control.value.trim() === '')) return { required: true };
            if (document.documentElement.lang === 'en') {
                controlValue = Number(control.value.replace(',', '').replace('$', '').replace(' ', ''));
                if (isNaN(controlValue)) {
                    controlValue = control.value.slice(0, -1);
                    controlValue = Number(controlValue.toString().replace(',', '').replace('$', '').replace(' ', ''));
                }
            }
            else {
                controlValue = Number(control.value.replace(',', '.').replace(' $', '').replace(' ', ''));
                if (isNaN(controlValue)) {
                    controlValue = Number(control.value.toString().replace(',', '.').replace(' $', '').replace(' ', '').slice(0, -1));
                }
            }
            if (controlValue > max || controlValue <= 0) {
                return { wrongRequestedAmount: true };
            }
            return null;
        };
    }
    static validateNumber(control: FormControl): ValidationResult {
        if (control.value.length === 0) return null;
        let replacedValue;
        if (document.documentElement.lang === 'en') {
            replacedValue = control.value.replace(new RegExp(',', 'g'), '');
        } else {
            replacedValue = control.value.replace(new RegExp(' ', 'g'), '').replace(',', '.');
        }
        let valid = !isNaN(replacedValue);
        if (!valid) {
            control.setValue(control.value.slice(0, -1));
        }
        return null;
    }

    static incomeValidator = (min: number, max: number) => {
        return (control: FormControl) => {
            let controlValue;
            if (control.value.length === 1 && control.value.trim() === '') return { required: true };
            if (document.documentElement.lang === 'en') {
                controlValue = Number(control.value.replace(',', '').replace('$', '').replace(' ', ''));
                if (isNaN(controlValue)) {
                    controlValue = control.value.slice(0, -1);
                    controlValue = Number(controlValue.toString().replace(',', '').replace('$', '').replace(' ', ''));
                }
            }
            else {
                controlValue = Number(control.value.replace(',', '.').replace(' $', '').replace(' ', ''));
                if (isNaN(controlValue)) {
                    controlValue = Number(control.value.toString().replace(',', '.').replace(' $', '').replace(' ', '').slice(0, -1));
                }
                if ((controlValue.toString().split('.')[0] || []).length > 6) {
                    controlValue = Number(control.value.toString().replace(',', '.').replace(' $', '').replace(' ', '').slice(0, -1));
                    control.setValue(controlValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(".", ",") + ' $');
                }
                if ((controlValue.toString().split('.')[1] || []).length > 2) {
                    controlValue = Number(control.value.toString().replace(',', '.').replace(' $', '').replace(' ', '').slice(0, -1));
                    control.setValue(controlValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(".", ",") + ' $');
                }
            }

            if (controlValue > max || controlValue <= 0 || controlValue < min) {
                if (controlValue !== 0) {
                    return { wrongRequestedAmount: true };
                }
            }
            return null;
        };
    }

    static maxValueValidator = (max: number) => {
        return (control: FormControl) => {
            var error = null;
            if (document.documentElement.lang === 'en') {
                if (Number(control.value.replace(new RegExp(',', 'g'), '').replace('$', '')) === 0 && control.value !== '') {
                    error = { wrongRequestedAmount: true };
                }
                if (Number(control.value.replace(new RegExp(',', 'g'), '').replace('$', '')) > max && control.value !== '') {
                    error = { notAvailableCredit: true };
                }
            }
            else {
                if (Number(control.value.replace(new RegExp(' ', 'g'), '').replace(',', '.').replace('$', '')) === 0 && control.value !== '') {
                    error = { wrongRequestedAmount: true };
                }
                if (Number(control.value.replace(new RegExp(' ', 'g'), '').replace(',', '.').replace('$', '')) > max && control.value !== '') {
                    error = { notAvailableCredit: true };
                }

            }

            return error;
        };
    }

    static sinValidator(control: FormControl): ValidationResult {
        let SIN_REGEXP = /([0-9]{3})([0-9]{3})([0-9]{3})/;
        let isDigit = true;
        if (control.value.length === 1 && isNaN(control.value)) isDigit = false;
        if (control.value.length === 10 || !isDigit) {
            control.setValue(control.value.slice(0, -1));
        }
        if (control.value.length === 0) return null;
        var valid = SIN_REGEXP.test(control.value);
        if (!valid) {
            return { format: true };
        }
        return null;
    }

    static accountValidator(control: FormControl): ValidationResult {
        let ACCOUNT_REGEXP = /([0-9]{4})([ ]?)([0-9]{4})([ ]?)([0-9]{4})([ ]?)([0-9]{4})/;
        if (control.value.length === 0) return null;
        if (control.value.length === 20) {
            control.setValue(control.value.slice(0, -1));
        }
        var valid = ACCOUNT_REGEXP.test(control.value);
        if (!valid) {
            return { format: true };
        }
        return null;
    }

    static authorizationValidator(control: FormControl): ValidationResult {
        let AUTHORIZATION_REGEXP = /([0-9]{6})/;
        if (control.value.length === 1 && isNaN(control.value)) control.setValue(control.value.slice(0, -1));
        if (control.value.length === 0) return null;
        var valid = AUTHORIZATION_REGEXP.test(control.value);
        if (!valid) {
            return { format: true };
        }
        return null;
    }

    static dateValidator(control: FormControl): ValidationResult {
        var DATE_REGEXP = /(^(((0[1-9]|1[0-9]|2[0-8])(0[1-9]|1[012]))|((29|30|31)(0[13578]|1[02]))|((29|30)(0[4,6,9]|11)))(19|[2-9][0-9])\d\d$)|(^2902(19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
        if (control.value.length === 0) return null;

        var valid = DATE_REGEXP.test(control.value.replace(/\D+/g, ''));
        if (!valid) {
            return { format: true };
        }
        return null;
    }

    static expiryValidator(control: FormControl): ValidationResult {
        var EXPIRY_REGEXP = /(^(((0[1-9]|1[0-9]|2[0-8])(0[1-9]|1[012]))|((29|30|31)(0[13578]|1[02]))|((29|30)(0[4,6,9]|11)))(19|[2-9][0-9])\d\d$)|(^2902(19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
        if (control.value.length === 0) return null;
        var inputDate = control.value.replace(/\D+/g, '');
        var valid = EXPIRY_REGEXP.test(inputDate);
        if (!valid) {
            return { format: true };
        }
        if (valid) {
            var today = new Date();
            var isGreaterThanToday = (new Date(inputDate.substring(4, 8), inputDate.substring(2, 4) - 1, inputDate.substring(0, 2)) > today) ? true : false;
            if (!isGreaterThanToday) return { notValidDate: true }
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/utils/flx-validators.ts